/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./cityPageFrens.vue?vue&type=template&id=74189314&scoped=true"
import script from "./cityPageFrens.vue?vue&type=script&lang=js"
export * from "./cityPageFrens.vue?vue&type=script&lang=js"
import style0 from "./cityPageFrens.vue?vue&type=style&index=0&id=74189314&prod&lang=scss"
import style1 from "./cityPageFrens.vue?vue&type=style&index=1&id=74189314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74189314",
  null
  
)

export default component.exports